import React from "react";
import "./mission.css";

function Mission() {
  return (
    <div className="lb_mission_wrap">
      <div className="lb_mission_container">
        <div className="mission-grid">
          <div className="mission-box">
            <h4 className="lb_mission_title">Vision</h4>
            <p className="lb_mission_text">
              Our Vision is to support needy students by Mentoring & Counseling
              them enabling them choose right career option.
            </p>
          </div>

          <div className="mission-box">
            <h4 className="lb_mission_title">Mission</h4>
            <p className="lb_mission_text">
              To contribute to students society by showing them the right path
              during their "Learning" process. We aim to feel the "Joy of
              giving" by providing complete information on Learning Techniques &
              Career.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mission;
